import React from "react";
import Modal from "react-bootstrap/Modal";
import useLang from "Shared/hooks/useLanguage";

interface DeleteSensitivityModalProps {
  show: boolean;
  panelName?: string;
  isDeleting?: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const DeleteSensitivityModal: React.FC<DeleteSensitivityModalProps> = ({
  show,
  panelName,
  isDeleting = false,
  onHide,
  onConfirm,
}) => {
  const { t } = useLang();

  return (
    <Modal show={show} onHide={onHide} backdrop="static" keyboard={false}>
      <Modal.Header closeButton className="bg-light-primary m-0 p-5">
        <Modal.Title className="h5 fw-bold mb-0">{t("Delete Antimicrobial")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t("Are you sure you want to delete this antimicrobial panel?")}
        {panelName ? (
          <div className="fw-bold mt-2">{panelName}</div>
        ) : null}
      </Modal.Body>
      <Modal.Footer className="p-0">
        <button
          type="button"
          className="btn btn-secondary"
          disabled={isDeleting}
          onClick={onHide}
        >
          {t("Cancel")}
        </button>
        <button
          type="button"
          className="btn btn-danger m-2"
          disabled={isDeleting}
          onClick={onConfirm}
        >
          {isDeleting ? t("Deleting...") : t("Delete")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteSensitivityModal;
